// REST 客户端（非流式部分）。SSE 流式见 sse.ts。
import type { ClientConfig, HistoryTurn, SessionSummary, Source } from "./types";

export class RateLimitError extends Error {
  constructor() {
    super("rate-limited");
    this.name = "RateLimitError";
  }
}

async function getJSON<T>(url: string): Promise<T> {
  const r = await fetch(url, { headers: { Accept: "application/json" } });
  if (r.status === 429) throw new RateLimitError();
  if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
  return (await r.json()) as T;
}

export const api = {
  config: () => getJSON<ClientConfig>("/api/config"),

  sessions: (userId: string) =>
    getJSON<{ sessions: SessionSummary[] }>(`/api/sessions?user_id=${enc(userId)}`).then(
      (d) => d.sessions,
    ),

  async deleteSession(userId: string, sessionId: string): Promise<void> {
    const r = await fetch(`/api/sessions/${enc(sessionId)}?user_id=${enc(userId)}`, {
      method: "DELETE",
    });
    if (r.status === 404) return;
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
  },

  history: (userId: string, sessionId: string) =>
    getJSON<{ session_id: string; turns: HistoryTurn[]; prefs: Record<string, unknown> }>(
      `/api/history?user_id=${enc(userId)}&session_id=${enc(sessionId)}`,
    ),

  // 非流式兜底（EventSource 不可用时）
  async chat(body: {
    question: string;
    user_id: string;
    session_id: string;
    script: string;
  }): Promise<{ answer: string; sources: Source[]; grounded: boolean; session_id: string }> {
    const r = await fetch("/api/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (r.status === 429) throw new RateLimitError();
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  },
};

export function enc(s: string): string {
  return encodeURIComponent(s);
}
